export default "__VITE_ASSET__CXvi0Jrv__";